import { type ReactNode, useCallback, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import Notification from '@/components/Notification';
import { type NotificationType, useNotification } from '@/providers/Notification';

const getNotificationType = (type: NotificationType): 'default' | 'success' | 'error' | 'info' => {
  switch (type) {
    case 'success':
      return 'success';
    case 'error':
      return 'error';
    default:
      return 'default';
  }
};

const NotificationWrapper = () => {
  const { notifications, removeNotification, removeAllNotifications } = useNotification();
  const { pathname } = useLocation();

  useEffect(() => {
    removeAllNotifications();
  }, [pathname, removeAllNotifications]);

  const getSimpleNotification = useCallback(
    (key: string | undefined, type: NotificationType, message: ReactNode) => (
      <Notification
        key={key}
        type={getNotificationType(type)}
        size="medium"
        onClose={() => removeNotification({ key })}
      >
        {message}
      </Notification>
    ),
    [removeNotification],
  );

  const items = useMemo(
    () => notifications.map((val) => getSimpleNotification(val.key, val.type, val.message)),
    [notifications, getSimpleNotification],
  );

  return notifications.length ? <>{items}</> : <></>;
};

export default NotificationWrapper;
